goog.provide("shadow.js.shim.module$src$svg$wpp$content_actions$edit_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content_actions$edit_svg");
shadow.js.shim.module$src$svg$wpp$content_actions$edit_svg = shadow.js.nativeProvides["src/svg/wpp/content-actions/edit.svg"] = shadow$bridge("src/svg/wpp/content-actions/edit.svg");
module$shadow_js_shim_module$src$svg$wpp$content_actions$edit_svg.default = shadow.js.shim.module$src$svg$wpp$content_actions$edit_svg;
